"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConvertSavedBlockForTCDC_1 = __importDefault(require("Project/BlockNew/SavedBlocks/ConvertSavedBlockForTCDC"));
var Preview = require("Project/BlockNew/SavedBlocks/Preview/Preview");
var ContentEditor = require("Project/BlockNew/SavedBlocks/ContentEditor/ContentEditor");
var SavedBlockOpener = (function () {
    function SavedBlockOpener(make, savedBlockService, invoke, telemetry) {
        var _this = this;
        this.make = make;
        this.savedBlockService = savedBlockService;
        this.telemetry = telemetry;
        this.edit = function (block, origin, isNewSavedBlock) {
            if (isNewSavedBlock === void 0) { isNewSavedBlock = false; }
            _this.convertSavedBlockForTCDC(block);
            return _this.make(ContentEditor, {
                block: block,
                isNewSavedBlock: isNewSavedBlock,
                origin: origin,
            });
        };
        this.preview = function (block, origin) {
            _this.convertSavedBlockForTCDC(block);
            _this.telemetry.track("Saved Block Previewed", { saved_block_origin: origin });
            return _this.make(Preview, {
                block: block,
                origin: origin,
            });
        };
        this.convertSavedBlockForTCDC = invoke(ConvertSavedBlockForTCDC_1.default);
    }
    return SavedBlockOpener;
}());
exports.default = SavedBlockOpener;
